import { Component, OnInit } from '@angular/core';
import { LookupAdminService } from '../services/lookups/lookupadmin.service';
import { ReleaseNote } from '../models/user.model';
import {AccordionModule} from 'primeng/accordion';

@Component({
  selector: 'app-release-note',
  templateUrl: './release-note.component.html',
  styleUrls: ['./release-note.component.css']
})

export class ReleaseNoteComponent implements OnInit {

releaseNotes: ReleaseNote[];

  constructor(private lookupAdminService: LookupAdminService) { }

  ngOnInit() {
    this.LoadReleaseNotes();
  }

  private LoadReleaseNotes(){
    //("start This is ReleaseNotes data");
     this.lookupAdminService.getAllReleaseNotes$()
    .subscribe(data=>{

      this.releaseNotes = data;
      //console.log("This is ReleaseNotes data");
      //console.log(this.releaseNotes);

    });
  }

}
